import { render } from "./SpinnerLoading.vue?vue&type=template&id=3389d7c6&scoped=true"
import script from "./SpinnerLoading.vue?vue&type=script&lang=js"
export * from "./SpinnerLoading.vue?vue&type=script&lang=js"

import "./SpinnerLoading.vue?vue&type=style&index=0&id=3389d7c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3389d7c6"]])

export default __exports__